import { blue, green, grey, orange, red } from './colors';
import { action } from './action';
import { background } from './background';
import { error } from './error';
import { greyOption } from './grey';
import { primary } from './primary';
import { secondary } from './secondary';
import { text } from './text';
import { warning } from './warning';
import { info } from './info';
import { success } from './success';
import { status } from './status';
import { border } from './border';
import { illustration } from './illustration';
/**
 * Returns the MUI PaletteOptions for the given mode.
 */ export function getPaletteOptions(mode) {
    // Palette options should be split out into their own files with functions
    // for creating the option values based on light/dark mode
    return {
        mode,
        primary: primary(mode),
        secondary: secondary(mode),
        grey: greyOption(mode),
        background: background(mode),
        action: action(mode),
        text: text(mode),
        error: error(mode),
        warning: warning(mode),
        info: info(mode),
        success: success(mode),
        // Custom colors
        designSystem: {
            blue,
            green,
            grey,
            orange,
            red
        },
        status: status(mode),
        border: border(mode),
        illustration: illustration(mode),
        // A contrast threshold of 4.5:1 is required to meet AA
        // https://mui.com/material-ui/customization/palette/#accessibility
        contrastThreshold: 4.5
    };
}

//# sourceMappingURL=palette-options.js.map